import { Component, OnInit } from '@angular/core';
import { NotificationService } from 'app/main/shared/notification.service';
import { AuthenticationService } from 'app/services/authentication.service';
import { DatabindingService } from 'app/services/databinding.service';
import { LocalStorageService } from 'app/services/localStorage.service';
import { AVLS_ID, MDB_ID, PNS_ID,AFCS_ID, OPRSCounterBooking_ID, HRMS_ID ,SystemURLs,environment,encryptStorage,GRMS_ID,DMS_ID} from 'environments/environment';
import { first } from 'rxjs/operators';
import { Common } from 'utility/common';
import { StartupPageService } from './startup-page.service';
import { FormControl,FormBuilder, Validators,FormGroup } from '@angular/forms';
import { DialogService, DialogRef } from '@progress/kendo-angular-dialog';
import { Validations } from 'utility/validators';
import { parseJSON } from 'jquery';
import { PasswordStrengthValidator } from 'utility/password-strength.validators';
import { ActivatedRoute, Router } from '@angular/router';
import { OPRS_REPORTS_ID } from '../../../environments/environment';

@Component({
  selector: 'ngx-startup-page',
  templateUrl: './startup-page.component.html',
  styleUrls: ['./startup-page.component.scss']
})
export class StartupPageComponent implements OnInit {
  public editChangePasswordForm: FormGroup = new FormGroup({
    id: new FormControl(),
    password: new FormControl('', Validators.compose([Validators.required, Validators.minLength(8), PasswordStrengthValidator])),
    confirmpassword: new FormControl('', Validators.required)
  });
  public systemList:any[] =[];
  public isMDB = false;
  public isPNS = false;
  public isAVLS = false;
  public isDMS = false;
  public isOPRSCounter = false;
  public isOPRSReport = false;
  public isHRMS = false;
  public isAFCS = false;
  public isGRMS = false;

  public isOPRSClicked = false;

  public SSOData:any;
  
  public validations = Validations;

  OPRSCounterForm = this.formBuilder.group({
    //username: [null, Validators.required],
    //password: [null, Validators.required],
    terminal: [null, Validators.required],
    intTerminalID: [null],
    intWindowID: [null, Validators.required],
    //clientId: [null],
    intDepotID: [null],
    strDepotName: [null],
});
isChangePassword = false;
password: string;
confirmpassword: string;
public lstWindow:any=[];
public lstWindowCpyFilter:any=[];

  constructor(  private formBuilder: FormBuilder,private databindingService:DatabindingService,
    private authenticationService: AuthenticationService,
    private startupPageService:StartupPageService,
    private notifyService: NotificationService,
    private route: ActivatedRoute,
    private router: Router) { }
    
  public currentUser = this.authenticationService.currentUserValue;
  public UserName = this.currentUser.userName;

  ngOnInit(): void 
  {
    Common.hideloader();
    this.GetUserSystemMappings();
    this.StoreUserStorage();
  }

  GetUserSystemMappings()
  {
    var userID = LocalStorageService.getUserID();
    // this.databindingService
    //   .GetUserSystemMappings(userID)
    //   .pipe(first())
    //   .subscribe(result => {
        
        this.systemList = parseJSON(localStorage.getItem('AssignedSystemList')); // result.data;
        
        for(let i = 0; i< this.systemList.length ;i++)
        {
          if(this.systemList[i] == MDB_ID)
          {
            this.isMDB = true;
            continue;
          }

          if(this.systemList[i] == PNS_ID)
          {
            this.isPNS = true;continue;
          }

          if(this.systemList[i] == AVLS_ID)
          {
            this.isAVLS = true;continue;
          }

          if(this.systemList[i] == OPRSCounterBooking_ID)
          {
            this.isOPRSCounter = true;continue;
          }

          if(this.systemList[i] == HRMS_ID)
          {
            this.isHRMS = true;continue;
          }
          if(this.systemList[i] == AFCS_ID)
          {
            this.isAFCS = true;continue;
          }
          if(this.systemList[i] == GRMS_ID)
          {
            this.isGRMS = true;continue;
          }
          if(this.systemList[i] == DMS_ID)
          {
            this.isDMS = true;continue;
          }
          if(this.systemList[i] == OPRS_REPORTS_ID)
          {
            this.isOPRSReport = true;continue;
          }
        }
      // });
  }

  PNS_StoreSessionData()
  {
    Common.showloader();
    this.SSOData = [];
     var data = {
      accessToken: this.currentUser.token,
      refreshToken: this.currentUser.refreshToken,
      userid: this.currentUser.userId,
      username: this.currentUser.userName,
      idamuserid: this.currentUser.idamUserId,
      refNumber:this.currentUser.refNumber
     }

     this.startupPageService
      .StoreSessionData(data)
      .pipe(first())
      .subscribe(result => {
        
        this.SSOData = result.data;
        Common.hideloader();
        if(this.SSOData != null)
        {
          if(this.SSOData.landingPageUrl == "")
          {
            this.notifyService.showWarning("No menu assign of this system please assign the menu first.","Warning");
          }
          else
          {
            window.open(this.SSOData.landingPageUrl, "_blank");
          }
         
        }
      });
  }

  LogOut()
  {
    this.authenticationService.logout();
  }
/**MDB SSO START */
  MDBNavigation()
  {
    // alert(this.authenticationService.landingPage)
    //this.router.navigate([this.authenticationService.landingPage]);
    window.open(SystemURLs["MDB_URL"]+this.authenticationService.landingPage, "_blank");
   
  }

  /**MDB SSO ENDs */

  /**OPRS SSO START */
  OPRSCounterNavigation()
  {
    window.open(SystemURLs["OPRSCOUNTER_URL"]+"?username="+this.currentUser.userName, "_blank");
  }

  /**OPRS SSO ENDS */


  /**AFCS SSO START */

  AFCSNavigation()
  {
    window.open(SystemURLs["AFCSUrl"]+"?username="+this.currentUser.userName, "_blank");
  }
  
  /**AFCS SSO ENDS */

  GRMSNavigation(){
    window.open(SystemURLs["GRMSUrl"]+"?username="+this.currentUser.userName, "_blank");
  }

  AVLSNavigation()
  {
    window.open(SystemURLs["AVLSUrl"]+"?username="+this.currentUser.userName, "_blank");
  }

  PNSNavigation()
  {
    window.open(SystemURLs["PNS_URL"]+"?username="+this.currentUser.userName, "_blank");
  }

  DMSNavigation()
  {
    window.open(SystemURLs["DMS_URL"]+"?username="+this.currentUser.userName, "_blank");
  }
  HRMSNavigation()
  {
    window.open(SystemURLs["HRMS_URL"]+"?username="+this.currentUser.userName, "_blank");
  }
  OPRSReportNavigation()
  {
    window.open(SystemURLs["OPRS_REPORT_URL"]+"?username="+this.currentUser.userName, "_blank");
  }
  
StoreUserStorage(){
  Common.showloader();
  this.SSOData = [];
   var data = {
    accessToken: this.currentUser.token,
    refreshToken: this.currentUser.refreshToken,
    userid: this.currentUser.userId,
    username: this.currentUser.userName,
    idamuserid: this.currentUser.idamUserId,
    refNumber:this.currentUser.refNumber
   }

   this.startupPageService
    .StoreUserStorage(data)
    .pipe(first())
    .subscribe(result => {
      this.SSOData = result.data;
      Common.hideloader();
      if(this.SSOData != 1)
      {
        
          this.notifyService.showWarning("No menu assign of this system please assign the menu first.","Warning");
      }
    });
    
}
public closeChangePassword(status) {
  this.password = '';
  this.isChangePassword = false;
  this.editChangePasswordForm.reset();
}

public openChangePassword() {
  
  this.editChangePasswordForm.reset();
  this.isChangePassword = true;
} 

updatePassword() {
  if (this.password == this.confirmpassword) {
    //  Common.showloader();
    this.editChangePasswordForm.value.id = this.authenticationService.currentUserValue.idamUserId;
    let reqPara: any = {};
    reqPara.id=this.editChangePasswordForm.value.id;
    reqPara.password=this.editChangePasswordForm.value.password;
    reqPara.access_Token = this.authenticationService.currentUserValue.token;
    this.authenticationService
      .UpdatePassword(reqPara)
      .pipe()
      .subscribe(
        res => {
          if(res.IsSuccess)
          {
            this.notifyService.showSuccess('Password Changed SuccessFully','Success')
            //  Common.hideloader();

          }
        },
      );
      this.notifyService.showSuccess('Password Changed SuccessFully','Success')

      this.closeChangePassword(true);
  }
  else {
    this.notifyService.showWarning('Passwords do not match', 'Warning')
  }
}
}
